// MaterialsSelector.tsx
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { getSelectedMover } from "@/store/mover/slice";
import { LineItem, Material } from "@/types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

interface MaterialsSelectorProps {
  onAdd: (
    materials: Array<{ material: Material; price?: number; quantity?: number }>
  ) => void;
  currentLineItems: LineItem[];
  onClose: () => void;
}

const MaterialsSelector: React.FC<MaterialsSelectorProps> = ({
  onAdd,
  currentLineItems,
  onClose,
}) => {
  const selectedMover = useSelector(getSelectedMover);
  const [quantities, setQuantities] = useState<Record<number, number>>({});
  const [prices, setPrices] = useState<Record<number, number>>({});

  useEffect(() => {
    const initialQuantities: Record<number, number> = {};
    const initialPrices: Record<number, number> = {};

    selectedMover?.materials.forEach((material) => {
      const lineItem = currentLineItems.find(
        (item) => item.name === material.name
      );
      if (lineItem) {
        initialQuantities[material.id] = lineItem.qty || 0;
        initialPrices[material.id] = lineItem.price || material.price;
      } else {
        initialQuantities[material.id] = 0;
        initialPrices[material.id] = material.price;
      }
    });

    setQuantities(initialQuantities);
    setPrices(initialPrices);
  }, [currentLineItems, selectedMover]);

  // const handleAddMaterial = (material: Material) => {
  //   onAdd([
  //     {
  //       material,
  //       price: prices[material.id] || material.price,
  //       quantity: quantities[material.id] || 0,
  //     },
  //   ]);
  // };

  const saveMaterials = () => {
    const allMaterials = selectedMover?.materials
      .map((material) => ({
        material,
        price: prices[material.id] || material.price,
        quantity: quantities[material.id] || 0,
      }))
      .filter((material) => material.quantity > 0);

    onAdd(allMaterials || []);
    onClose();
  };

  // const isMaterialAdded = (material: Material) => {
  //   return currentLineItems.some(
  //     (item) =>
  //       item.name === material.name &&
  //       item.category === "materials" &&
  //       !item._destroy
  //   );
  // };

  const handleQuantityChange = (index: number, quantity: number) => {
    setQuantities((prev) => ({ ...prev, [index]: quantity }));
  };

  const handlePriceChange = (index: number, price: number) => {
    setPrices((prev) => ({ ...prev, [index]: price }));
  };

  return (
    <div className="mt-4">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Material</TableHead>
            <TableHead>Unit Price</TableHead>
            <TableHead>Quantity</TableHead>
            <TableHead>Total</TableHead>
            {/* <TableHead className="w-24"></TableHead> */}
          </TableRow>
        </TableHeader>
        <TableBody>
          {[...(selectedMover?.materials || [])]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((material) => (
              <TableRow key={material.id}>
                <TableCell className="max-w-[200px]">
                  <div className="flex flex-col">
                    <span className="font-semibold">{material.name}</span>
                    {material.description && (
                      <span className="text-sm text-gray-700">
                        {material.description}
                      </span>
                    )}
                  </div>
                </TableCell>
                <TableCell>
                  <Input
                    type="number"
                    className="w-16"
                    defaultValue={material.price}
                    value={prices[material.id]}
                    onChange={(e) =>
                      handlePriceChange(material.id, parseFloat(e.target.value))
                    }
                    onFocus={(e) => e.target.select()}
                  />
                </TableCell>
                <TableCell>
                  <Input
                    type="number"
                    className="w-16"
                    defaultValue={0}
                    value={quantities[material.id]}
                    onChange={(e) =>
                      handleQuantityChange(
                        material.id,
                        parseFloat(e.target.value)
                      )
                    }
                    onFocus={(e) => e.target.select()}
                  />
                </TableCell>
                <TableCell>
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(prices[material.id] * quantities[material.id])}
                </TableCell>
                {/* <TableCell>
                  {isMaterialAdded(material) ? (
                    <span className="text-sm text-gray-700">Added</span>
                  ) : (
                    <Button
                      size="sm"
                      onClick={() => handleAddMaterial(material)}
                    >
                      Add
                    </Button>
                  )}
                </TableCell> */}
              </TableRow>
            ))}
        </TableBody>
      </Table>

      <div className="sticky -bottom-6 left-0 right-0 bg-white px-4 py-2">
        <Button onClick={() => saveMaterials()} className="w-full">
          Add Materials
        </Button>
      </div>
    </div>
  );
};

export default MaterialsSelector;
